import React from 'react';
import { Select, Button, Spin } from 'antd';
import moment from 'moment';

interface Branch {
  id: string;
  bname: string;
  fulladdress: string;
}

interface DateRange {
  from_date: string;
  to_date: string;
}

interface FilterProps {
  branchId: Branch | null;
  setBranch: (branch: Branch | null) => void;
  query?: string;
  date: DateRange;
  loading?: boolean;
  onFilterChange: (filters: { branchId?: string }) => Promise<void>;
  branches: Branch[];
}

const Filters: React.FC<FilterProps> = ({ 
  branchId, 
  setBranch, 
  query, 
  date, 
  loading,
  onFilterChange,
  branches 
}) => {
  const clearBranch = () => {
    setBranch(null);
    onFilterChange({ branchId: undefined });
  };

  const handleBranchSelect = (value: string) => {
    if (value === 'all') {
      setBranch(null);
      onFilterChange({ branchId: 'all' });
    } else {
      const selectedBranch = branches.find(branch => branch.id === value);
      if (selectedBranch) {
        setBranch(selectedBranch);
        onFilterChange({ branchId: selectedBranch.id });
      }
    }
  };

  return (
    <div>
      {/* Branch selector */}
      <div style={{ marginBottom: '16px' }}>
        <Select
          style={{ width: '100%' }}
          placeholder="Select branch"
          value={branchId?.id || 'all'}
          onChange={handleBranchSelect}
          options={[
            { value: 'all', label: 'All Branches' },
            ...branches.map(branch => ({
              value: branch.id,
              label: branch.bname
            }))
          ]}
        />
      </div>

      {/* Active filters display */}
      <div style={{
        backgroundColor: '#f9f9f9',
        padding: '10px',
        borderRadius: '6px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{
            fontSize: '13px',
            color: '#333',
            flex: 1
          }}>
            {!branchId?.id && 'All branches - '}
            {query ? `'${query}' ` : ''}
            {`${moment(date.from_date).format('MMMM DD')} to ${moment(
              date.to_date
            ).format('LL')}`}
          </div>

          {loading ? (
            <Spin size="small" />
          ) : branchId?.id ? (
            <Button type="link" onClick={clearBranch} danger>
              Clear
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Filters;

const styles = `
.branch-filter {
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: #fff;
  border-radius: 6px;
  margin-bottom: 8px;
  cursor: pointer;
}

.branch-text {
  margin: 0 8px;
  font-size: 14px;
  flex: 1;
}

.filters {
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 6px;
}

.filter-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.filter-text {
  font-size: 13px;
  color: #333;
  flex: 1;
}

.loading-spinner {
  color: #1890ff;
}

.store-icon, .dropdown-icon {
  color: grey;
}
`;
